export enum ChatConfigUIStateEnum {
   SearchState = 'SEARCH_STATE',
   ChatState = 'CHAT_STATE',
   ChatHistory = 'CHAT_HISTORY'
}

export const LOADING_MESSAGE_ID = -1

export const SYSTEM_MESSAGE_SENDER_ID = 'SYSTEM'

export const LOADING_MESSAGE_INITIAL_CONTENT = '...'

export const RESPONSE_LOADING_CONTENT = {
   QUERIED_TO_AI: 'QUERIED_TO_AI',
   RETRIEVING_INFO: 'RETRIEVING_INFO',
   EXTRACTING_INFO: 'EXTRACTING_INFO'
}
